export default __webpack_public_path__ + "static/media/EG_Mix-4.5419e5fe.wav";